import * as runbookModules from 'src/store/modules/runbooks'

export const MUTUAL_EXCLUSION_TOOLTIP =
    'Cannot use both template and CSV upload at the same time.'

export const RUNBOOK_CATEGORY = Object.freeze([
    { value: 'cybersecurity', label: 'Cybersecurity' },
    { value: 'failover', label: 'Failover' },
    { value: 'restart', label: 'Restart' },
])

export const validate = (state, id) => {
    const runbook = runbookModules.getRunbook(state, id)
    if (!runbook) return false
    const { name, organization, orgPk, mode, parameters } = runbook
    if (!organization || !orgPk || !name) {
        return false
    }
    return !(
        (mode === runbookModules.DR_SOLUTIONS_RESTART ||
            mode === runbookModules.DR_SOLUTIONS_FAILOVER) &&
        parameters.length === 0
    )
}

export const NO_MATCHING_TEMPLATES = 'No matching templates are available.'
export const LOADING_TEMPLATES = 'Loading templates...'
